<script>
import Base from "@/components/RequestDetailsForDefaultVue/RequestCalls.vue";

export default {
  name: "CustomerServiceFilesRequestCalls",
  extends: Base,
};
</script>
